<template lang="pug">
  #ScannerInStore
    .header-container.d-flex.align-items-center(style="margin-bottom: 0.3rem;")
      b-button.bg-white(
        style="padding: 0.7rem; align-items: center; width: fit-content; display: flex; border-radius: 30px;"
        @click="goBack"
      )
        b-icon(style="color: #181818;" icon="arrow-left")
      span.header-title.pl-2.text-white {{ headerTitle }}

    .camera-permission-warning(v-if="showPermissionWarning")
      p.text-danger.text-center.mb-0 No se pudo acceder a la cámara, por favor habilita los permisos de la cámara en el navegador
      b-button.bg-danger.text-white(
        style="border-radius: 30px; margin-top: 0.5rem; width: 100%;"
        @click="requestCameraPermission"
      ) Habilitar cámara

    qrcode-stream.qr-container(
      :key="qrStreamKey"
      @detect="onDetect"
      @init="onInit"
    )
    .qr-container-loader.text-center(v-if="loader")
      b-spinner.float
    b-button.bg-white(v-b-modal.scanned-success-deliveries-modal style="border-radius: 30px; margin-top: 0.3rem; padding: 0.71rem; align-items: center; width: fit-content; display: flex;")
      b-icon(style="padding-top: 0.12rem; color: #181818;" icon="list-ul")
      span.pl-2.code-counter(v-if="scannedSuccess && deliveries.length > 0") {{ deliveries.length }}

    b-modal#scanned-success-deliveries-modal(ref="scannedSuccessDeliveries" hide-footer :title="modalTitle" centered)
      scanned-deliveries(
        :deliveries="deliveries"
        @clear="clearDeliveries"
      )

  </template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { mapActions } from 'vuex'
import ScannedDeliveries from './ScannedDeliveries.vue'

export default {

  components: {
    QrcodeStream,
    ScannedDeliveries
  },
  data () {
    return {
      code: [],
      deliveries: [],
      scannedSuccess: 0,
      loader: false,
      success_audio: null,
      error_audio: null,
      qrStreamKey: '',
      showPermissionWarning: false
    }
  },
  mounted () {
    const currentDate = this.$moment.tz(new Date(), 'America/Santiago').format('YYYY-MM-DD')
    const storedDate = localStorage.getItem(this.localStorageScanDateKey)
    if (currentDate !== storedDate) {
      this.clearDeliveries()
    }
    this.deliveries = JSON.parse(localStorage.getItem(this.localStorageScanKey)) || []
    this.scannedSuccess = this.deliveries.length
    this.success_audio = new Audio('success_scan.mp3')
    this.error_audio = new Audio('error_scan.wav')
  },
  computed: {
    scanType () {
      const currentRoute = this.$route.path

      switch (currentRoute) {
        case '/cambios-devoluciones':
          return 'cambio-devolucion'
        case '/escaner-en-tienda':
          return 'escaneo-tienda'
        case '/recepcion-en-bodega':
          return 'recepcion-bodega'
        case '/escaner-ruta-conductor':
          return 'ruta-conductor'
        default:
          return 'scan-otros'
      }
    },
    modalTitle () {
      const currentRoute = this.$route.path

      switch (currentRoute) {
        case '/cambios-devoluciones':
          return 'Paquetes escaneados para cambio o devolución'
        case '/escaner-en-tienda':
          return 'Paquetes escaneados en tienda'
        case '/recepcion-en-bodega':
          return 'Paquetes escaneados para recepción en bodega'
        case '/escaner-ruta-conductor':
          return 'Paquetes escaneados en ruta conductor'
        default:
          return 'Paquetes escaneados'
      }
    },
    localStorageScanKey () {
      const currentRoute = this.$route.path

      switch (currentRoute) {
        case '/cambios-devoluciones':
          return 'scan-cambio-devolucion'
        case '/escaner-en-tienda':
          return 'scan-tienda'
        case '/recepcion-en-bodega':
          return 'scan-bodega'
        case '/escaner-ruta-conductor':
          return 'scan-ruta-conductor'
        default:
          return 'scan-otros'
      }
    },
    localStorageScanDateKey () {
      const currentRoute = this.$route.path

      switch (currentRoute) {
        case '/cambios-devoluciones':
          return 'scan-cambio-devolucion-date'
        case '/escaner-en-tienda':
          return 'scan-tienda-date'
        case '/recepcion-en-bodega':
          return 'scan-bodega-date'
        case '/escaner-ruta-conductor':
          return 'scan-ruta-conductor-date'
        default:
          return 'scan-otros-date'
      }
    },
    headerTitle () {
      const currentRoute = this.$route.path

      switch (currentRoute) {
        case '/cambios-devoluciones':
          return 'Escaner cambios - devoluciones'
        case '/escaner-en-tienda':
          return 'Escaner en Tienda'
        case '/recepcion-en-bodega':
          return 'Escaner recepción en Bodega'
        case '/escaner-ruta-conductor':
          return 'Escaner ruta conductor'
        default:
          return 'Escaner'
      }
    }
  },
  methods: {
    ...mapActions(['packageScanning', 'listPackage']),
    async scanCode (code) {
      try {
        await this.packageScanning({ codes: [code], scan_type: this.scanType })
        this.$root.$bvToast.toast(`El paquete ${code} fue actualizado con éxito!`, {
          title: 'Éxito',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 7000,
          solid: true
        })
      } catch (err) {
        this.$root.$bvToast.toast(err.response.data.message || 'No se pudo marcar el paquete', {
          title: 'Error',
          variant: 'danger'
        })
      }
    },
    async clearDeliveries () {
      this.deliveries = []
      localStorage.setItem(this.localStorageScanKey, JSON.stringify([]))
      localStorage.setItem(this.localStorageScanDateKey, this.$moment.tz(new Date(), 'America/Santiago').format('YYYY-MM-DD'))
    },
    goBack () {
      this.$router.back()
    },
    isIOS () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    },
    async onDetect (promise) {
      try {
        this.loader = true
        const {
          content
        } = await promise
        console.log(content.split('/recepcion-de-paquetes/')[1], 'contenido')
        const deliveryId = content.split('/recepcion-de-paquetes/')[1]
        const duplicated = this.deliveries.filter(d => d.code === deliveryId)
        if (deliveryId) {
          if (duplicated.length) {
            await this.error_audio.play()
            this.loader = false
            return this.$bvToast.toast(`El paquete ${deliveryId} ya fue escaneado`, {
              title: 'Error',
              variant: 'danger',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 7000,
              solid: true
            })
          }
          if (deliveryId) {
            await this.success_audio.play()
            const delivery = await this.listPackage({ code: deliveryId })

            if (delivery.status !== 200) {
              return this.$bvToast.toast(`No se pudo obtener el paquete ${deliveryId}`, {
                title: 'Error',
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 7000,
                solid: true
              })
            }
            this.loader = false
            await this.scanCode(deliveryId)
            this.code.push(deliveryId)
            this.deliveries.push({ code: deliveryId, commune: delivery.data.commune.name, address: delivery.data.customerAddress, customerName: delivery.data.customerName, store: delivery.data.withdrawal.store })
            localStorage.setItem(this.localStorageScanKey, JSON.stringify(this.deliveries))
            localStorage.setItem(this.localStorageScanDateKey, this.$moment.tz(new Date(), 'America/Santiago').format('YYYY-MM-DD'))

            this.scannedSuccess += 1
          } else if (!deliveryId) {
            this.loader = false
            console.log('Error al intentar cambiar estado')
          }
        } else {
          this.loader = false
          return this.$bvToast.toast(`Código de paquete inválido: ${deliveryId}`, {
            title: 'Error',
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 7000,
            solid: true
          })
        }
      } catch (error) {
        this.loader = false
        await this.error_audio.play()
        console.log('error al intentar leer Código Qr')
        return this.$bvToast.toast(`Ocurrió un error: ${error}`, {
          title: 'Error',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 7000,
          solid: true
        })
      }
    },
    async onInit (promise) {
      try {
        await promise // Espera a que la cámara se inicialice correctamente
        this.showPermissionWarning = false
      } catch (error) {
        console.error('Error al inicializar la cámara:', error)
        if (error.name === 'NotAllowedError') {
          // Permiso denegado por el usuario
          this.showPermissionWarning = true
        } else if (error.name === 'NotFoundError') {
          // No se encontró ninguna cámara en el dispositivo
          this.showPermissionWarning = true
        } else {
          // Otro tipo de error
          this.showPermissionWarning = true
        }

        if (this.isIOS()) {
          this.$bvToast.toast('Por favor, recarga la página para habilitar los permisos de la cámara.', {
            title: 'Permiso de cámara requerido',
            variant: 'warning',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 7000,
            solid: true
          })
        }
      }
    },
    async requestCameraPermission () {
      if (this.isIOS()) {
        // Si es iOS, recargar la página para forzar la solicitud de permisos nuevamente
        window.location.reload()
      } else {
        // Para otros dispositivos, reiniciar el componente QrcodeStream
        this.qrStreamKey = Date.now()
      }
    }
  },
  watch: {
    '$route.path': {
      handler (newPath) {
        // console.log(value, 'Ruta cambiada')
        this.deliveries = JSON.parse(localStorage.getItem(this.localStorageScanKey)) || []

        // Reiniciar el QrcodeStream
        this.qrStreamKey = Date.now()
      }
    },
    deep: true
  }
}

</script>

  <style lang="scss" scoped>
  #ScannerInStore {
    background-color: #191919;
    height: 100%;
    display: flex;
    flex-direction: column;
    .qr-container {
      padding: 0.4rem 0rem;

      .qrcode-stream-camera {
        border-radius: 15px;
      }
    }
    .qr-container-loader {
      align-items: center;
      display: flex;
      justify-content: center;
      height: 100%;
      height: calc(100% - 170px);
      position: absolute;
      width: 93%;
    }
  }
  </style>
  <style lang="scss">
  #scanned-success-deliveries-modal {
    .modal-dialog-centered {
      align-items: end !important;
    }
    .modal-content {
      border-radius: 16px 16px 0 0 !important;
      transition-timing-function: ease-out !important;
      transition-duration: 300ms !important;

      .modal-body {
        padding: 0.7rem 0.4rem;
        padding-bottom: 0;
      }
      .table th, .table td {
        padding: 0.4rem;
        vertical-align: middle;
        font-size: 15px;
        font-weight: 400;
      }
    }
  }
  .code-counter {
    color: #13475c;
  }
  </style>
